const SourceIdTableData = (
  state = {
    loading: true,
    error: false,
    responseType: "",
    message: "",
    data: {},
  },
  action
) => {
  switch (action.type) {
    case "GET_SOURCE_ID_DATA_LOADING":
      return {
        ...state,
        loading: true,
        responseType: "",
        data: {},
      };

    case "GET_SOURCE_ID_DATA":
      return {
        ...state,
        loading: false,
        responseType: action.payload.data.responseType,
        data: action.payload.data.responseData?.map((val) => {
          return { ...val, key: val?.Id };
        }),
      };
    case "GET_SOURCE_ID_DATA_FAILED":
      return {
        ...state,
        loading: false,
        responseType: action.response.data.responseType,
        error: action.response.data.responseData,
      };

    default:
      return state;
  }
};

export default SourceIdTableData;
